import Typography, { type TypographyVariants } from '@cobliteam/ui/components/Typography';
import { cn } from '@cobliteam/ui/utils';
import { Fragment, type ReactNode } from 'react';

const BOLD_OPEN = '<bold>';
const BOLD_CLOSE = '</bold>';
// The capture group keeps the <bold>…</bold> delimiters so emphasized runs survive `String.split`.
const BOLD_TAG = /(<bold>[\s\S]*?<\/bold>)/g;

export const stripHighlightMarkup = (text: string): string => (text ? text.replace(/<\/?bold>/g, '') : '');

export const renderRiskHighlight = (text: string, strongClassName = 'font-semibold'): ReactNode[] =>
  (text ?? '')
    .split(BOLD_TAG)
    .filter((part) => part.length > 0)
    .map((part, index) => {
      const key = `${index}:${part.slice(0, 16)}`;
      if (part.startsWith(BOLD_OPEN) && part.endsWith(BOLD_CLOSE)) {
        return (
          <strong key={key} className={strongClassName}>
            {part.slice(BOLD_OPEN.length, -BOLD_CLOSE.length)}
          </strong>
        );
      }
      // Texto literal do backend: não força caixa-baixo nas partes não-destacadas — isso corrompia
      // siglas ("GPS"→"Gps") e nomes próprios ("João da Silva"→"João da silva").
      return <Fragment key={key}>{part}</Fragment>;
    });

interface RiskHighlightTextProps {
  text: string;
  className?: string;
  variant?: TypographyVariants;
}

const RiskHighlightText = ({ text, className, variant = 'text-md' }: RiskHighlightTextProps) => (
  <Typography as='p' variant={variant} className={cn('text-start', className)}>
    {renderRiskHighlight(text)}
  </Typography>
);

export default RiskHighlightText;
